var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06836 0.380859L2.8125 2.63672L1.93164 1.75586L0.943359 2.74414L2.31836 4.11914L2.8125 4.5918L3.30664 4.11914L6.05664 1.36914L5.06836 0.380859ZM8.3125 1.5625V2.9375H17.25V1.5625H8.3125ZM5.06836 5.88086L2.8125 8.13672L1.93164 7.25586L0.943359 8.24414L2.31836 9.61914L2.8125 10.0918L3.30664 9.61914L6.05664 6.86914L5.06836 5.88086ZM8.3125 7.0625V8.4375H17.25V7.0625H8.3125ZM5.06836 11.3809L2.8125 13.6367L1.93164 12.7559L0.943359 13.7441L2.31836 15.1191L2.8125 15.5918L3.30664 15.1191L6.05664 12.3691L5.06836 11.3809ZM8.3125 12.5625V13.9375H17.25V12.5625H8.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryMenu);
export default __webpack_public_path__ + "static/media/inventory-menu.8b73c7c24f97db3cc463d2f9b64b2148.svg";
export { ForwardRef as ReactComponent };